









































































































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HelloWorld extends Vue {
  @Prop() msg!: string;
  count = 0;

  thingClicked(): void {
    this.count++;
  }
}
